import React, { useState } from 'react';

import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';

export const FingotiTooltip = ({ children, title, ...rest }) => {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const [open, setOpen] = useState(false);

    if (isDesktop) {
        return (
            <Tooltip title={title} {...rest}>
                {children}
            </Tooltip>
        );
    } else {
        return (
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Tooltip
                    onClick={() => setOpen(true)}
                    onMouseEnter={() => setOpen(true)}
                    open={open}
                    PopperProps={{
                        disablePortal: true,
                    }}
                    title={title}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    {...rest}
                >
                    {children}
                </Tooltip>
            </ClickAwayListener>
        );
    }

}